import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../../Common/ies-http-client.service';
import { AppUrl } from '../../../Common/appUrl';

@Injectable()
export class AdmBlacklistExamService {

  constructor(private _httpClient: IesHttpClient) {
  }

  // fetch location data based on Id
  getExamList(locationId: number) {
    return this._httpClient.get(AppUrl.getExamList, locationId);
  }

  //Update Black List exam
  updateBlacklistExam(params: any) {
    return this._httpClient.post(AppUrl.updateBlackListedExam, params);
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location-setting/adm-blacklist-exam/adm-blacklist-exam.service.ts